module.exports = __webpack_public_path__ + "static/media/cc_square.24be20ab.png";